import GroupsWithAccess from './GroupsWithAccess/GroupsWithAccess'
import SharedGroupsAlert from './SharedGroupsAlert/SharedGroupsAlert'
import ViewVisibilityOptions from './ViewVisibilityOptions/ViewVisibilityOptions'

const ViewVisibilityFields = ({
  visibility,
  onChangeVisibility,
  groups,
  selectedGroupIds,
  fixedGroupIds,
  selectedGroups,
  showSharedGroupsAlert,
  showGroupsWithAccess,
  loadingGroups,
  onToggleGroup,
}) => {
  return (
    <>
      <ViewVisibilityOptions value={visibility} onChange={onChangeVisibility} />
      {showSharedGroupsAlert && <SharedGroupsAlert groups={selectedGroups} />}
      {showGroupsWithAccess && (
        <GroupsWithAccess
          groups={groups}
          selectedGroupIds={selectedGroupIds}
          fixedGroupIds={fixedGroupIds}
          loading={loadingGroups}
          onToggleGroup={onToggleGroup}
        />
      )}
    </>
  )
}

export default ViewVisibilityFields
